import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { ProgressCircle } from "@chakra-ui/react"
import Tagihan from './pages/Tagihan';
import Units from './pages/Units';
import Home from './pages/Home';
import { useSelector } from 'react-redux';
import UnitDetail from './pages/UnitDetail';
const Application = ()=>{
const isLoading = useSelector(state=>{
      return state.userContext.isLoading
    });

    return(
        <BrowserRouter>
         <Loading isShown={isLoading}/>
      <Routes>
          <Route path="/home" element={<Home />} >
             <Route path="/home/tagihan" element={<Tagihan />} />
            <Route path="/home/unit" element={<Units />} /> 
            <Route path="/home/unit/:id" element={<UnitDetail />} />
          </Route>
          <Route path="*" element={<Navigate to="/home/unit" replace/>} />
        </Routes>
    </BrowserRouter>
    )
}

export default Application;

const Loading = ({isShown}) =>{
    return (
  <div style={{width:'100%', height:'100%',background:'rgb(0 0 0 / 4%)', position:'absolute', display:isShown ? 'flex':'none', justifyContent:'center', alignItems:'center',zIndex:'10',}}>
      <ProgressCircle.Root value={null} size="sm" >
      <ProgressCircle.Circle>
          <ProgressCircle.Track />
          <ProgressCircle.Range />
      </ProgressCircle.Circle>
      </ProgressCircle.Root>
  </div>
  )
  }